export const costs = [
  'Sleepless nights searching for ways to translate complex industrial instrumentation concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how industrial instrumentation connects to their futures, careers, or real-world process control.",
  "Awkward silences when a student asks about signal scaling or PLC programming and you don't have a clear answer.",
  'Weekends lost building lesson plans, instrumentation projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach measurement fundamentals, sensors, control systems, automation, or troubleshooting without adequate resources.',
];
